import { cssVar } from './themeVars';

export const palette = {
    panelBg: cssVar('panel-bg'),
    panelMuted: cssVar('panel-muted'),
    pageBg: cssVar('page-bg'),
    cardBorder: cssVar('card-border'),
    cardBorderStrong: cssVar('card-border-strong'),
    outlineGray: cssVar('outline-gray'),
    dimText: cssVar('dim-text'),

    accent: cssVar('accent'),
    accentHover: cssVar('accent-hover'),
    accentBg: cssVar('accent-bg'),
    accentBgHover: cssVar('accent-bg-hover'),
    accentBgStrong: cssVar('accent-bg-strong'),
    accentText: cssVar('accent-text'),

    softShadowSm: cssVar('soft-shadow-sm'),
    softShadowMd: cssVar('soft-shadow-md'),
    softShadowLg: cssVar('soft-shadow-lg'),
    dialogShadow: cssVar('dialog-shadow'),
    sidePanelShadow: cssVar('side-panel-shadow'),

    cardRadius: '16px',
    pillRadius: '999px',

    hoverTint: cssVar('hover-tint'),
    focusTint: cssVar('focus-tint'),

    brandGreen: '#158664',
    loggedAccent: '#158664',
    loggedPillBg: cssVar('logged-pill-bg'),
    loggedPillText: '#158664',

    pendingAccent: '#C026D3',
    pendingPillBg: cssVar('pending-pill-bg'),
    pendingPillText: cssVar('pending-pill-text'),
    pendingCardBg: cssVar('pending-card-bg'),

    selectedAccent: '#3B82F6',
    selectedBg: cssVar('selected-bg'),

    issueBadgeBg: cssVar('issue-badge-bg'),
    issueBadgeText: '#158664',
    bugBadgeBg: cssVar('bug-badge-bg'),
    bugBadgeText: '#B91C1C',
    requestBadgeBg: cssVar('request-badge-bg'),
    requestBadgeText: '#2563EB',

    savePrimary: '#10B981',
    savePrimaryHover: '#059669',
    addEntryBg: '#111827',
    addEntryBgHover: '#1F2937',
    addEntryDisabled: '#374151',

    backdrop: cssVar('backdrop'),

    overText: '#DC2626',
    equalText: '#16A34A',

    loggedText: '#111827',
    pendingText: '#CA8A04',

    addText: '#CA8A04',
    addBg: cssVar('add-bg'),
    updateText: '#3B82F6',
    updateBg: cssVar('update-bg'),
    removeText: '#DC2626',
    removeBg: cssVar('remove-bg'),

    // Aliased to the accent so primary action buttons follow the accent automatically.
    primaryBg: cssVar('accent'),
    primaryBgHover: cssVar('accent-hover'),
    primaryText: '#FFFFFF',

    goodAccent: cssVar('accent'),
    mutedAccent: '#9CA3AF',

    bugAccent: '#B91C1C',
    requestAccent: '#2563EB',
    holidayAccent: '#7EE5DC',
    holidayBg: cssVar('holiday-bg'),
    dayOffAccent: '#1F267D',
    dayOffBg: cssVar('day-off-bg'),
    todayAccent: '#DC2626',
    destructiveAccentHover: '#B91C1C',
    warningText: '#D97706',

    nonWorkingBg: cssVar('non-working-bg'),
    progressTrackBg: cssVar('progress-track-bg'),

    statusOnTrackBg: cssVar('status-on-track-bg'),
    statusOnTrackText: cssVar('status-on-track-text'),
    statusOnTrackAccent: '#16A34A',

    statusUnderBg: cssVar('status-under-bg'),
    statusUnderText: cssVar('status-under-text'),
    statusUnderAccent: '#EF4444',

    statusOverBg: cssVar('status-over-bg'),
    statusOverText: cssVar('status-over-text'),
    statusOverAccent: '#F97316',
} as const;

export const MONO_FONT = "'JetBrains Mono', 'SF Mono', ui-monospace, monospace";
